interface Props { mode: "collage" | "browse"; onChange: (m: "collage" | "browse") => void; }

export function ViewToggle({ mode, onChange }: Props) {
  return (
    <div class="toggle">
      <button class={mode === "collage" ? "active" : ""} onClick={() => onChange("collage")}>Collage</button>
      <button class={mode === "browse" ? "active" : ""} onClick={() => onChange("browse")}>Browse</button>
    </div>
  );
}
